export const WHATSAPP_E164_REGEX = /^\+[1-9]\d{7,14}$/;

export function normalizeWhatsAppNumber(value: string): string {
  const compact = value.trim().replace(/[\s()-]/g, "");

  if (compact.startsWith("00")) {
    return `+${compact.slice(2).replace(/\D/g, "")}`;
  }

  if (compact.startsWith("+")) {
    return `+${compact.slice(1).replace(/\D/g, "")}`;
  }

  return compact.replace(/\D/g, "");
}

export function isValidWhatsAppNumber(value: string): boolean {
  return WHATSAPP_E164_REGEX.test(normalizeWhatsAppNumber(value));
}
